import React, {Component} from 'react';
import {NavBar, DatePicker, List, Toast} from 'antd-mobile';
import "./style.less";
import {connect} from "react-redux";
import moment from 'moment';
import {walletDetail} from "../../../../service/homeService"
let nowDate = new Date();
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class AccountInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:[
            //     {icon:"icondingpiaotubiao",remarks:"云南顺佳捷汽车服务有限公司",drcrf:0,busitime:"06/08 12:00",amount:"158.00"},
            //     {icon:"icontixiantubiao",remarks:"云南顺佳捷",drcrf:1,busitime:"06/08 12:00",amount:"159.00"},
            //     {icon:"iconchongzhitubiao",remarks:"云南顺佳捷",drcrf:2,busitime:"06/08 12:00",amount:"151.00"},
            //     {icon:"icontuikuantubiao",remarks:"云南顺佳捷",drcrf:3,busitime:"06/08 12:00",amount:"152.00"},
            //     {icon:"iconqitafeiyongtubiao",remarks:"云南顺佳捷",drcrf:4,busitime:"06/08 12:00",amount:"153.00"},
            //     {icon:"icondingpiaotubiao",remarks:"云南顺佳捷",drcrf:0,busitime:"06/08 12:00",amount:"158.00"},
            //     {icon:"icontixiantubiao",remarks:"云南顺佳捷",drcrf:1,busitime:"06/08 12:00",amount:"159.00"},
            //     {icon:"iconchongzhitubiao",remarks:"云南顺佳捷",drcrf:2,busitime:"06/08 12:00",amount:"151.00"},
            //     {icon:"icontuikuantubiao",remarks:"云南顺佳捷",drcrf:3,busitime:"06/08 12:00",amount:"152.00"},
            //     {icon:"iconqitafeiyongtubiao",remarks:"云南顺佳捷",drcrf:4,busitime:"06/08 12:00",amount:"153.00"},
             ],
            date:nowDate,
            endDate:"",
        };
    }
    componentDidMount(){
        // let data = this.state.data;
        // data.map((res)=>{
        //     if(res.type == 0){
        //         res.type = "订票";
        //         res.icon = "icondingpiaotubiao"
        //     }
        //     if(res.type == 1){
        //         res.type = "提现";
        //         res.icon = "icontixiantubiao"
        //     }
        //     if(res.type == 2){
        //         res.type = "充值";
        //         res.icon = "iconchongzhitubiao"
        //     }
        //     if(res.type == 3){
        //         res.type = "退款";
        //         res.icon = "icontuikuantubiao"
        //
        //     }
        //     if(res.type == 4){
        //         res.type = "其他";
        //         res.icon = "iconqitafeiyongtubiao"
        //     }
        // });
        this.getData()

    }
    getData(date){
        let params ={
            token:this.props.userInfo.token,
            source:1,
            data:{
                beginDate:moment(date).format('YYYY-MM-01'),
                endDate:moment(date).endOf('month').format("YYYY-MM-DD"),
            },
        };
        console.log(params);
        walletDetail(params).then((res)=>{
            if(res.data.code === '0000'){
                this.setState({data:res.data.data});
            }else{
                Toast.info(res.data.msg,3);
            }
        })
    }
    onOk(date){
        this.setState({date:date,})
        this.getData(date)
    }
    render(){
        return(
            <div className="accountInfo">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >交易明细</NavBar>
                <div className="content">
                    <DatePicker
                        mode="month"
                        title="选择月份"
                        extra={moment(this.state.date).format('YYYY年MM月')}
                        minDate={new Date(moment().subtract(1, 'year').format("YYYY,MM"))}
                        maxDate={new Date()}
                        onChange={date => this.onOk(date)}
                    >
                        <List.Item arrow="horizontal" className="title"></List.Item>
                    </DatePicker>
                    <div className="listBox">
                        {
                            this.state.data.map((res,i)=>(
                                <div className="list" key={i}>
                                    <div>
                                        <i className={`icon iconfont ${res.drcrf == "1" ? "icontuikuantubiao" :"iconchongzhitubiao"}`}/>
                                        <div className="listText">
                                            <span className="resavName">{res.resavName}</span><span className="type">{res.remarks}{res.drcrf == "1" ? "支出" : "收入"} </span>
                                            <div className="time">{res.busidate} {res.busitime}</div>
                                        </div>
                                    </div>
                                    <span className="pic">{res.drcrf == "1" ? "-"+res.amount : "+"+res.amount}</span>
                                </div>
                            ))
                        }
                    </div>
                    {this.state.data.length > 0 ? null : <div className="noMore">暂无记录</div> }
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/Wallet/AccountInfo/index.js